var _desc, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sing-hanging") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction-Pop-Income-2",
    transform: "translate(-113.000000, -441.000000)",
    fill: "#0BBCD6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(26.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(67.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sing-hanging",
    transform: "translate(20.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2,
    y: 0,
    width: 2,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 1.33333333,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.66666667,
    y: 3.33333333,
    width: 1.33333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13.3333333,
    y: 3.33333333,
    width: 1.33333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5.33333333,
    y: 5.33333333,
    width: 10.6666667,
    height: 7.33333333
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.647494d94cfd31d09b12baa8fc18e2c4.svg";
export { ForwardRef as ReactComponent };